module.exports = __webpack_public_path__ + "img/16_14.c95d6fea.png";